<div class="bmc-alerts">
  <h5>{{'ALERTS.TITLE' | translate}}</h5>
  <jobs-table [jobType]="jobType" [jobState]="jobStates.Waiting" [title]="'ALERTS.MSG1_NOT_CONFIGURATED'" [subtitle]="'ALERTS.MSG2_NOT_CONFIGURATED'">
  </jobs-table>
</div>
